import {Component, forwardRef, Injector} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractMultiSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-multi-select-column.component";

@Component({
    selector: "wbo-extra-multi-select-column",
    templateUrl: "./extra-multi-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => ExtraMultiSelectColumnComponent), multi: true}
    ]
})
export class ExtraMultiSelectColumnComponent extends AbstractMultiSelectColumnComponent {

    constructor(injector: Injector) {
        super(injector, "id", "name");
    }
}
